<template>
  <CardFrame :bgColor="data.backgroundColor" hasDropShadow>
    <CardContainer>
      <CardHeaderContainer>
        <CardImage :image="image" :imageSize="'large'" />
        <Title class="text-center" :headingTag="'h2'" :style="'h2'">
          {{ data.title }}
        </Title>
      </CardHeaderContainer>
      <CardBodyContainer>
        <CardBody :textAlignment="'left'" :text="data.body"> </CardBody>
      </CardBodyContainer>
      <CardButtons :buttons="data.buttons"></CardButtons>
    </CardContainer>
  </CardFrame>
</template>

<script>
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardImage from "../../Atoms/Cards/CardImage.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardButtons from "../../Atoms/Cards/CardButtons.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBody,
    CardBodyContainer,
    CardButtons,
    CardContainer,
    CardImage,
    CardHeaderContainer,
    CardFrame,
    Title,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const image = props.data.hasOwnProperty("image")
      ? props.data.image
      : props.data.icon;

    return {
      image,
    };
  },
};
</script>
